export default "__VITE_ASSET__CvrSs9Eu__"